export enum CallbackType {
  Consultation = 'consultation',
  Order = 'order',
  ReportRequest = 'report_request',
  Question = 'question',
  EuroCharge = 'euro_charge',
}
